/**
 * Email validation regex pattern
 */
export const mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;

/**
 * Validates email format
 * @param {string} email - Email address to validate
 * @returns {boolean} True if valid email format
 */
export const isValidEmail = (email) => {
  return mailformat.test(email);
};

/**
 * Validates required field
 * @param {string} value - Value to validate
 * @param {string} fieldName - Name of the field
 * @returns {string} Error message if invalid, empty string if valid
 */
export const validateRequired = (value, fieldName = "Field") => {
  if (!value || !value.trim()) {
    return `${fieldName} is required`;
  }
  return "";
};

/**
 * Validates email field
 * @param {string} email - Email to validate
 * @returns {string} Error message if invalid, empty string if valid
 */
export const validateEmail = (email) => {
  const requiredError = validateRequired(email, "Email");
  if (requiredError) return requiredError;
  
  if (!isValidEmail(email)) {
    return "Please enter a valid email address";
  }
  
  return "";
};
